import CopyBtn from "./CopyBtn.vue"

export default CopyBtn
